import BettingHistory from "./BettingHistory";

export default BettingHistory